import { CheckboxFilter } from '@lifebit-ai/lds'
import React from 'react'

import { getExportRequestTypeFilterOptions } from 'modules/requests/utils'
import type { Option } from 'modules/types'

interface RequestTypeFilterProps {
  onApply: (filteredOptions: Option[]) => void
  onReset: () => void
}

export const RequestTypeFilter: React.FC<RequestTypeFilterProps> = ({ onApply, onReset }) => (
  <CheckboxFilter
    label="Request type"
    options={getExportRequestTypeFilterOptions()}
    onApply={onApply}
    onReset={onReset}
    withFuzzySearch={false}
  />
)
